import { render, staticRenderFns } from "./D-Dimer.vue?vue&type=template&id=3364f4b7&scoped=true&"
import script from "./D-Dimer.vue?vue&type=script&lang=js&"
export * from "./D-Dimer.vue?vue&type=script&lang=js&"
import style0 from "./D-Dimer.vue?vue&type=style&index=0&id=3364f4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364f4b7",
  null
  
)

export default component.exports